import React, { useState } from "react";
import Footer from "../components/Footer";
import GreyGridBackground from "../components/backgroundWhite";
import { FaBars, FaTimes } from "react-icons/fa";

/* =======================
   ASSETS (RELATIVE PATHS)
======================= */

// Header
import CleverPeLogo from "../assets/logo/CleverPe_Black_H.svg";

// Hero
import HeroMobile from "../assets/insurance/heroimage.png";

// Center section
import CenterMobile from "../assets/native/Screenshot (1179).png";
import IphoneFrame from "../assets/insurance/iphone.svg";
import Ellipse1 from "../assets/insurance/ellipse-1.svg";
import Ellipse2 from "../assets/insurance/ellipse-2.svg";
import Ellipse3 from "../assets/insurance/ellipse-3.svg";

// Why CleverPe
import WhyLogo from "../assets/logo/newlogo.png";
import IconInstant from "../assets/insurance/icon-instant.svg";
import IconTransparent from "../assets/insurance/icon-transparent.svg";
import IconConversion from "../assets/insurance/icon-conversion.svg";
import IconZeroImpact from "../assets/insurance/icon-zero-impact.svg";

const Insurance: React.FC = () => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <div className="min-h-screen flex flex-col relative">
            {/* ================= HEADER ================= */}
            <section className="relative overflow-hidden">
                {/* Grid background ONLY for header + hero */}
                <div className="absolute inset-0 -z-10">
                    <GreyGridBackground />
                </div>

                {/* ================= HEADER ================= */}
                <header className="relative z-50 py-6 bg-transparent">
                    <nav className="max-w-[1440px] mx-auto px-8">
                        <div className="flex items-center justify-between">
                            {/* Logo */}
                            <div className="flex-shrink-0">
                                <img
                                    src={CleverPeLogo}
                                    alt="CleverPe"
                                    className="h-[32px] w-auto"
                                />
                            </div>

                            {/* Hamburger Menu */}
                            <div className="md:hidden">
                                <button
                                    onClick={toggleMenu}
                                    className="text-gray-900 text-2xl focus:outline-none"
                                >
                                    {isMenuOpen ? <FaTimes /> : <FaBars />}
                                </button>
                            </div>

                            {/* Navigation */}
                            <div
                                className={`fixed inset-0 flex flex-col items-center justify-center space-y-6 bg-white transition-transform duration-300 ${isMenuOpen ? "translate-x-0" : "translate-x-full"
                                    } md:static md:flex md:flex-row md:space-y-0 md:space-x-14 md:translate-x-0 md:bg-transparent md:mx-auto`}
                            >
                                {isMenuOpen && (
                                    <button
                                        onClick={closeMenu}
                                        className="absolute top-4 right-4 text-gray-900 text-3xl md:hidden"
                                    >
                                        <FaTimes />
                                    </button>
                                )}

                                <a href="/" onClick={closeMenu} className="text-[16px] text-gray-700 hover:text-gray-900">
                                    Home
                                </a>
                                <a href="/#featurescard" onClick={closeMenu} className="text-[16px] text-gray-700 hover:text-gray-900">
                                    Solution
                                </a>
                                <a href="/#evfinancing" onClick={closeMenu} className="text-[16px] text-gray-700 hover:text-gray-900">
                                    Electric Vehicle
                                </a>
                                <a href="/Insurance" onClick={closeMenu} className="text-[16px] text-gray-700 hover:text-gray-900">
                                    Insurance
                                </a>
                                <a href="/Health" onClick={closeMenu} className="text-[16px] text-gray-700 hover:text-gray-900">
                                    Healthcare
                                </a>

                                <a href="/aboutus" onClick={closeMenu} className="text-[16px] text-gray-700 hover:text-gray-900">
                                    About
                                </a>
                            </div>
                        </div>
                    </nav>
                </header>

                {/* ================= HERO ================= */}
                <section className="relative py-16 md:py-20">
                    <div className="max-w-screen-xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
                        {/* LEFT */}
                        <div className="text-center md:text-left">
                            <h1 className="text-[36px] sm:text-[44px] md:text-[60px] font-bold leading-tight text-gray-900">
                                CleverPe Insurance <br className="hidden sm:block" />
                                Premium Financing
                            </h1>

                            <p className="mt-6 text-base sm:text-lg text-gray-600 max-w-xl mx-auto md:mx-0">
                                CleverPe Insurance Premium Financing is an embedded checkout solution
                                that allows customers to split high-value insurance premiums into
                                manageable EMIs—without paperwork, delays, or policy issuance friction.
                            </p>

                            <div className="mt-8 flex justify-center md:justify-start">
                                <button className="px-10 md:px-12 py-3 bg-gradient-purple text-white font-medium rounded-full">
                                    Enable Premium Financing
                                </button>
                            </div>
                        </div>

                        {/* RIGHT */}
                        <div className="flex justify-center md:justify-end mt-12 md:mt-0">
                            <img
                                src={HeroMobile}
                                alt="Insurance App"
                                className="w-[200px] sm:w-[250px] md:w-[350px] md:-translate-x-20 md:-translate-y-6"
                            />
                        </div>
                    </div>
                </section>
            </section>


            <main className="flex-grow">
                {/* ---------- CENTER FLOW ---------- */}
                <section className="relative py-2 overflow-hidden">

                    {/* ===== Responsive Headline ===== */}
                    <h2 className="text-center font-bold text-gray-900
                   text-2xl sm:text-3xl md:text-[40px]">
                        Remove Upfront Barriers from Insurance Premiums
                    </h2>

                    <p className="text-center text-gray-600 mt-2
                  text-base sm:text-lg mb-12 md:mb-20">
                        Let customers split high-value insurance premiums into flexible EMIs
                        in minutes.
                    </p>

                    {/* ================= DESKTOP VIEW (UNCHANGED) ================= */}
                    <div className="hidden md:block">
                        <div className="relative flex justify-center items-center mt-30">
                            {/* Ellipses */}
                            <img
                                src={Ellipse1}
                                className="absolute w-[660px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-[56%]"
                                alt="Outer Ellipse"
                            />
                            <img
                                src={Ellipse2}
                                className="absolute w-[570px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-[56%]"
                                alt="Middle Ellipse"
                            />
                            <img
                                src={Ellipse3}
                                className="absolute w-[480px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-[56%]"
                                alt="Inner Ellipse"
                            />

                            {/* Center mobile */}
                            <div className="relative z-10 w-[340px] -translate-y-4">
                                <img
                                    src={CenterMobile}
                                    alt="EMI Screen"
                                    className="w-full"
                                />
                            </div>
                        </div>

                        {/* ===== EXISTING STEPS (UNCHANGED) ===== */}
                        <div className="absolute top-1/2 left-1/2 w-full h-full
                        -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                            {/* STEP 1 */}
                            <div className="absolute w-12 h-12 rounded-full bg-black
                            flex items-center justify-center text-white
                            font-extrabold text-3xl"
                                style={{ top: '40%', left: '31%' }}>
                                1
                            </div>

                            <div className="absolute text-right"
                                style={{
                                    top: '41%',
                                    left: '31%',
                                    transform: 'translateX(-100%) translateX(-8px)',
                                }}>
                                <p className="font-medium text-black text-lg">
                                    Verify mobile number
                                </p>
                                <p className="text-gray-500 text-lg">
                                    Enter the OTP received
                                </p>
                            </div>

                            {/* STEP 2 */}
                            <div className="absolute w-12 h-12 rounded-full bg-black
                            flex items-center justify-center text-white
                            font-extrabold text-3xl"
                                style={{ bottom: '25%', left: '35%' }}>
                                2
                            </div>

                            <div className="absolute text-right"
                                style={{
                                    bottom: '21%',
                                    left: '35%',
                                    transform: 'translateX(-100%) translateX(-8px)',
                                }}>
                                <p className="font-medium text-black text-lg">
                                    Get instant approval
                                </p>
                                <p className="text-gray-500">
                                    Get instant pre-approval limit
                                </p>
                            </div>

                            {/* STEP 3 */}
                            <div className="absolute w-12 h-12 rounded-full bg-black
                            flex items-center justify-center text-white
                            font-extrabold text-3xl"
                                style={{ top: '35%', right: '33%' }}>
                                3
                            </div>

                            <div className="absolute text-left"
                                style={{
                                    top: '36%',
                                    right: '33%',
                                    transform: 'translateX(100%) translateX(8px)',
                                }}>
                                <p className="font-medium text-black text-lg">
                                    Choose EMI tenure
                                </p>
                                <p className="text-gray-500">
                                    Select the tenure as per<br />your wish
                                </p>
                            </div>

                            {/* STEP 4 */}
                            <div className="absolute w-12 h-12 rounded-full bg-black
                            flex items-center justify-center text-white
                            font-extrabold text-3xl"
                                style={{ bottom: '20%', right: '33%' }}>
                                4
                            </div>

                            <div className="absolute text-left"
                                style={{
                                    bottom: '19%',
                                    right: '33%',
                                    transform: 'translateX(100%) translateX(8px)',
                                }}>
                                <p className="font-medium text-black text-lg">
                                    Complete digital journey
                                </p>
                                <p className="text-gray-500">
                                    Complete your journey and that’s it!
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* ================= MOBILE VIEW (UPDATED) ================= */}
                    <div className="md:hidden px-6 mt-8 flex flex-col items-center">
                        {/* Mobile Image */}
                        <div className="relative z-10 w-[300px] sm:w-[340px] mb-6">
                            <img
                                src={CenterMobile}
                                alt="EMI Screen"
                                className="w-full"
                            />
                        </div>

                        {/* Steps */}
                        <ul className="w-full pl-14 space-y-8">
                            {[
                                ["Verify mobile number", "Enter the OTP received"],
                                ["Choose EMI tenure", "Select the tenure as per your wish"],
                                ["Get instant approval", "Get instant pre-approval limit"],
                                ["Complete digital journey", "Complete your journey and that’s it!"],
                            ].map(([title, desc], i) => (
                                <li key={i} className="flex gap-4">
                                    <div className="w-9 h-9 rounded-full bg-black text-white
                                flex items-center justify-center font-bold">
                                        {i + 1}
                                    </div>
                                    <div>
                                        <p className="font-semibold text-black">{title}</p>
                                        <p className="text-gray-500 text-sm">{desc}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>


                </section>


                {/* ---------- WHY CLEVERPE ---------- */}
                <section className="max-w-screen-xl mx-auto px-6 py-2 md:py-20 grid md:grid-cols-2 gap-20 items-center">
                    {/* Left image */}
                    <div className="flex justify-center md:justify-start translate-y-8 md:translate-y-8">
                        <img
                            src={WhyLogo}
                            alt="Why CleverPe"
                            className="w-[400px]"
                        />
                    </div>


                    {/* Right content */}
                    <div>
                        <h3 className="text-4xl font-bold text-center md:text-left">
                            Why CleverPe
                        </h3>

                        {/* Sub headline */}
                        <p className="text-lg text-gray-600 mt-2 mb-12 text-center md:text-left">
                            Built for Insurance Checkout
                        </p>

                        <ul className="space-y-6 pb-12 md:pb-0">
                            {[
                                { icon: IconInstant, text: "Instant EMI options at premium payment" },
                                { icon: IconTransparent, text: "Transparent pricing & flexible tenures" },
                                { icon: IconConversion, text: "Higher conversion on high-value policies" },
                                { icon: IconZeroImpact, text: "Zero impact on underwriting workflows" },
                            ].map((item, i, arr) => (
                                <li key={i}>
                                    {/* Icon + Text */}
                                    <div className="flex items-center gap-4">
                                        <img src={item.icon} className="w-10 h-10" alt="" />
                                        <span className="text-xl text-black">
                                            {item.text}
                                        </span>
                                    </div>

                                    {/* Underline except last item */}
                                    {i !== arr.length - 1 && (
                                        <div className="mt-3 w-full h-[1.5px] bg-gray-400" />
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>

                </section>

            </main>

            {/* ================= FOOTER ================= */}
            <Footer bgColor="bg-[#2F2E2E]" />
        </div>
    );
};

export default Insurance;
